module.exports = __webpack_public_path__ + "img/imagem-planta-palmeiras02.ce95b131.png";